/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Статус заявки реферальной программы
 */
export enum ReferralApplicationStatus {
    PENDING = 'pending',
    REVIEWING = 'reviewing',
    ACCEPTED = 'accepted',
    REJECTED = 'rejected',
}
